import {useWindowSize} from '@wandb/weave/common/hooks/useWindowSize';
import {Button} from '@wandb/weave/components';
import React from 'react';

import {trackAddPanels} from '../../services/analytics/addPanelsEvents';
import {type Ref as PanelBankSectionConfigRef} from '../../state/views/panelBankSectionConfig/types';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';

type AddPanelsDrawerButtonProps = {
  targetSectionRef?: PanelBankSectionConfigRef;
};

export const AddPanelsDrawerButton = ({
  targetSectionRef,
}: AddPanelsDrawerButtonProps) => {
  const {responsiveSize} = useWindowSize();
  const {openWorkspaceDrawer} = useWorkspaceDrawerContext();

  if (responsiveSize === 'small') {
    return null;
  }

  const scope = targetSectionRef ? 'section' : 'global';

  return (
    <Button
      data-test={`add-vis-${scope}`}
      className="add-vis-button"
      twWrapperStyles={{display: 'block'}}
      variant={targetSectionRef ? 'ghost' : 'primary'}
      icon="add-new"
      onClick={() => {
        openWorkspaceDrawer('add-panels', targetSectionRef);
        trackAddPanels({
          action: 'Drawer opened',
          scope,
        });
      }}>
      Add panels
    </Button>
  );
};
